import React from 'react';
import t from 'tcomb-form';

import baseFormFactory from './BaseForm';
import types from './validators/index';

import {ValidatonError} from '../resources/GenericResource';

import PasswordFieldComponent from '../components/PasswordFieldComponent';
import PhoneFieldComponent from '../components/PhoneFieldComponent';


const RegistrationModel = t.struct({
    first_name: t.Str,
    last_name: t.Str,
    company_name: t.Str,
    phone: t.Str,
    email: types.email,
    password: t.Str
});


function pwdInputTemplate(locals){
    return (
        <PasswordFieldComponent {...locals}/>
    );
}

function phoneInputTemplate(locals){
    return (
        <PhoneFieldComponent {...locals}/>
    );
}

function formLayout(locals){
    let renderedInputs = Object.keys(locals.inputs).map(function(key){
        return fieldLayout(locals.inputs[key]);
    });
    return (
        <div>
            {renderedInputs}
        </div>
    );
}

function fieldLayout(field){
    return (
        <label className="form-control form-control-text">
            {field}
        </label>
    );
}

const Form = baseFormFactory(RegistrationModel, true, true);

class RegistrationForm extends Form {
    constructor(props) {
        super(props);
        let isValid = false;

        this.state = {
            isValid: isValid,
            value: props.initialFormData
        };
    }

    getModel() {
        return this.props.model || RegistrationModel;
    }

    getOptions() {
        const errors = this.props.errors;

        return {
            auto: 'placeholders',
            order: ['first_name', 'last_name', 'email', 'company_name', 'phone', 'password'],
            template: formLayout,

            fields: {
                first_name: {
                    type: 'text',
                    hasError: !!errors,
                    error: errors && errors['first_name'] ? 'This field is required' : null
                },

                last_name: {
                    type: 'text',
                    hasError: !!errors,
                    error: errors && errors['last_name'] ? 'This field is required' : null
                },

                email: {
                    type: 'text',
                    hasError: !!errors,
                    error: (errors && errors['email'] ? 'Please enter a valid email' : null) || (errors.error && errors.error.errors['email'] ? errors.error.errors['email'] : null)
                },

                company_name: {
                    type: 'text',
                    hasError: !!errors,
                    error: errors && errors['company_name'] ? 'This field is required' : null
                },

                phone: {
                    type: 'text',
                    hasError: !!errors,
                    label: 'Phone',
                    template: phoneInputTemplate,
                    error: (errors && errors['phone'] ? 'This field is required' : null) || (errors.error && errors.error.errors ? errors.error.errors.phone : null)
                },

                password: {
                    type: 'password',
                    hasError: !!errors,
                    label: 'Password',
                    template: pwdInputTemplate,
                    error: errors && errors['password'] ? 'This field is required' : null
                }
            }
        };
    }

    render() {
        return (
            <div>
                <t.form.Form ref="form" value={this.state.value} type={this.getModel()} options={this.buildOptions()} onChange={this.onChange.bind(this)} />
                <button className="btn btn-orange">Sign up</button>
            </div>
        );
    }

}

RegistrationForm.propTypes = {
    initialFormData: React.PropTypes.object,
    model: React.PropTypes.object
};


export default RegistrationForm;



/** WEBPACK FOOTER **
 ** ./app/src/forms/RegistrationForm.js
 **/